import React from 'react';

import { Modeler } from './wro/modeler'
import { WroContext } from './wro/wro-context'
import { ModelFactory, WroModel, WroStatus } from './wro/wro-model'
import * as layerUtil from './wro/wro-layer-util'
import * as wroColormaps from './wro/wro-colormaps'

interface State {
  wroModel: WroModel
  wroStatus: WroStatus
}

export default class SuitabilityModeler extends React.Component<any, State> {
  modelerRef

  constructor(props: any) {
    super(props);
 
    this.modelerRef = React.createRef()
    const wroContext = this.props.wroContext;
    const wroStatus = ModelFactory.newWroStatus()
    let wroModel = null;
    if (this.props.wroModel) wroModel = ModelFactory.cloneModel(this.props.wroModel)
    this.state = {
      wroModel: wroModel,
      wroStatus: wroStatus
    }

    //wroColormaps.initLabels(wroContext.nls)
    // const wroContext = this.wroContext = new WroContext()
    // wroContext.nls = this.nls
    // wroContext.getConfig = (): any => this.props.config
    // wroContext.getId = (): string => this.props.id
    // wroContext.getLabel = (): string => null
    // wroContext.getPortal = (): any => null
    // wroContext.getPortalUrl = (): string => null
    // wroContext.getTheme = (): any => this.props.theme
    // wroContext.getUser = (): any => this.props.user
    //wroContext.getView = (): any => this.state.jimuMapView?.view
    wroContext.modelController.onModelChange = this.onWroModelChange
    wroContext.modelController.onStatusChange = this.onWroStatusChange

  }

  componentDidMount () {
    // if (typeof this.props._onMount === "function") {
    //   this.props._onMount(this);
    // } else if (typeof this.props.onMount === "function") {
    //   this.props.onMount(this);
    // }
  }

  componentWillUnmount() { 
  }

  onWroModelChange = (wroModel: WroModel, wasCleared?: boolean): void => {
    try {
      if (wasCleared) {
        const clearGfx = this.modelerRef?.current?.chartPanelRef?.current?.handleClearClicked
        if (clearGfx) clearGfx()
      }
    } catch (ex) {
      console.error(ex)
    }
    
    this.setState({
      wroModel: wroModel
    })
  }

  onWroStatusChange = (wroStatus: WroStatus): void => {
    this.setState({
      wroStatus: wroStatus
    })
  }

  render() {
    const wroContext: WroContext = this.props.wroContext
    const wroModel: WroModel = this.state.wroModel
    const wroStatus: WroStatus = this.state.wroStatus
    return (
      <div className='widget-wro'>
        <Modeler ref={this.modelerRef}
          wroContext={wroContext} wroModel={wroModel} wroStatus={wroStatus}
        />
      </div>
    )
  }

}